<template>
  <aside class="menu" :style="styleMenu">
    <perfect-scrollbar>
    <Tree
      :data="treeData"
      :options="treeOptions"
      :filter="treeFilter"
      ref="tree"
    />
    </perfect-scrollbar>
  </aside>
</template>

<script>
import { mapState } from "vuex";
import Tree from "liquor-tree";
import { baseApiUrl } from "@/global";
import axios from "axios";

export default {
  name: "Menu",
  components: { Tree },
  computed: {
    ...mapState(["isMenuVisible"]),
    styleMenu() {
      if (!this.isMenuVisible) {
        return "min-width: 0; max-width: 0; width: 0;";
      } else if (this.$mq === "xs" || this.$mq === "sm") {
        return "width: 100vw;";
      } else {
        return "";
      }
    },
  },
  data: function () {
    return {
      treeFilter: "",
      treeData: this.getTreeData(),
      treeOptions: {
        propertyNames: { text: "name" },
        filter: { emptyText: "Categoria não encontrada" },
      },
    };
  },
  methods: {
    getTreeData() {
      const url = `${baseApiUrl}/api/publico/menu`;
      return axios.get(url).then((res) => res.data);
    },
    getPath(node) {
      let path = node.data.text;
      let father = node.parent;
      while (father !== null) {
        path = `${father.data.text}_${path}`;
        father = father.parent;
      }
      return path.toLowerCase().replace(/ /g, "-");
    },
    onNodeSelect(node) {
      if (node.children.length === 0) {
        const path = this.getPath(node);
        this.$router.push({
          name: "articlesByCategory",
          params: {
            id: node.id,
            name: path,
          },
        });
      }

      if (this.$mq === "xs" || this.$mq === "sm") {
        this.$store.commit("toggleMenu", false);
      }
    },
  },
  mounted() {
    this.$refs.tree.$on("node:selected", this.onNodeSelect);
  },
};
</script>

<style>
.menu {
  grid-area: menu;
  /* background: linear-gradient(to right, #6c757d, #ced4da); */
  background-color: #000000;
  font-size: 0.9rem;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  min-width: 285px;
  max-width: 800px;
  height: calc(100vh - 48px);
  transition: all 0.5s ease;
}

.menu a,
.menu a:hover {
  color: #fff;
  text-decoration: none;
}

/* background-color: rgba(255, 255, 255, 0.1); */
.menu .tree-node.selected > .tree-content {
  border-left: solid 2px rgb(255, 251, 0);
  color: rgb(255, 251, 0) !important;
  background: rgba(115, 134, 3, 0.5) !important;
}
.menu .tree-node .tree-content:hover {
  background-color: rgba(255, 255, 255, 0.2) !important;
}

.tree-arrow.has-child {
  filter: brightness(6);
}

/* .menu .menu-filter {
  display: flex;
  justify-content: center;
  align-items: center;

  margin: 20px;
  padding-bottom: 8px;
  border-bottom: 1px solid #aaa;
}

.menu .menu-filter i {
  color: #aaa;
  margin-right: 10px;
} */

/* .menu input {
  color: #ccc;
  font-size: 1rem;
  border: 0;
  outline: 0;
  width: 100%;
  background: transparent;
} */

.tree-filter-empty {
  color: #ccc;
  font-size: 1rem;
  margin-left: 20px;
}

/* @keyframes slide-in {
  from {
    transform: translateX(0px);
  }
  to {
    transform: translateX(40px);
  }
}

@keyframes slide-out {
  from {
    transform: translateX(40px);
  }
  to {
    transform: translateX(0px);
  }
}

.slide-enter-active {
  animation: slide-in 0.2s ease;
  transition: opacity 4s;
}

.slide-leave-active {
  animation: slide-out 0.2s ease;
  transition: opacity 4s;
}
.slide-enter,
.slide-leave-to {
  opacity: 0;
} */
</style>